export const questionTypeEnum = {
    MultipleChoiceQuestionType: 'MultipleChoiceQuestion',
    QuestionTexteATrouType: 'QuestionTexteATrou',
    QuestionOuverteType: 'QuestionOuverte',
    CodingGameType: 'CodingGame',
};
